/** *******  所有模板下载  ******** */
export const importSalesmanExcel = {
  url: '/excel/salesman.xlsx'
};

export const importFaceRecognitionInviteExcel = {
  url: '/excel/aountName.xlsx'
};

export const importMerchandiseExcel = {
  url: '/excel/merchandise.xlsx'
};

export const importCustomerExcel = {
  url: '/excel/Customer.xlsx'
};

export const importCustomerImportExcel = {
  url: '/excel/customerImport.xlsx'
};

export const importMerIntroductionExcel = {
  url: '/excel/merIntroduction.xls'
};

export const importTrainMaterialExcel = {
  url: '/excel/trainMaterial.xls'
};

export const importBranchCustRelationExcel = {
  url: '/excel/importBranchCustRelation.xlsx'
};

export const importSurveyDataExcel = {
  url: '/excel/普查表客户数据-批量导入模板.xlsx'
};

export const importPrizeManageExcel = {
  url: '/excel/prizeManageImport.xlsx'
};
